import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const supportRequestsCategoriesAdapter = getAdapter({ idFieldName: 'value' });

const supportRequestsCategoriesSlice = createSlice({
  name: 'supportRequestsCategories',
  initialState: supportRequestsCategoriesAdapter.getInitialState(),
  reducers: {
    setSupportRequestsCategories: (state, { payload: { supportRequestsCategories } }) => {
      supportRequestsCategoriesAdapter.setAll(state, supportRequestsCategories);
    },
  },
});

const selectors = supportRequestsCategoriesAdapter.getSelectors(({ supportRequestsCategories }) => supportRequestsCategories);

export const getSupportRequestsCategories = (state) => selectors.selectAll(state);

export const {
  setSupportRequestsCategories,
} = supportRequestsCategoriesSlice.actions;

export default supportRequestsCategoriesSlice.reducer;
